import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { GetEquipmentsList } from '../../store/FLEET/Equipments/equipmentsSlice';
import { useTranslation } from 'react-i18next';

const useGetEquipmentsList = () => {
  const dispatch = useAppDispatch();

  const { i18n, t } = useTranslation();
  const { EquipmentsList, loading, error } = useAppSelector(state => state.Equipments);

  useEffect(() => {
    if (EquipmentsList?.length === 0) {
      dispatch(GetEquipmentsList());
    }
  }, []);

  const OptionsEquipments = EquipmentsList?.map(item => ({
    value: item.id,
    label: i18n.language === 'en' ? item.plateNo : item.plateNo,
    // label: i18n.language === 'en' ? item.name : item.name2,
    PathImage: item?.image?.filePath || null,
    deiverName: i18n.language === 'en' ? item.peopleName : item.peopleName2,
    IsVacant: item.peopleName === null
  }));

  return { EquipmentsList, OptionsEquipments, loading, error };
};

export default useGetEquipmentsList;
